<template>
    <div>
        <ForceNewsBlockWrapper :requireCharacters="requireCharacters"
                               :titleLabel="$t('profile.label.person_in_charge_name')"
                               :parentScreen="parentScreen">
            <div class="form-group row">
                <label class="control-label col-md-3 col-form-label" for="picLastName">{{$t('profile.label.pic_last_name')}}</label>
                <div class="col-md-6">
                    <input type="text" class="form-control"
                           v-model="$v.input['amsCustomerDetail.picLastName'].$model"
                           id="picLastName"
                           name="picLastName"
                           required
                           maxlength="20"
                           v-convert-halfwidth-to-fullwidth>
                    <div v-if="$v.input['amsCustomerDetail.picLastName'].$error || $v.input['amsCustomerDetail.picLastName'].$anyError"
                         class="error-messages ng-active">
                        <div v-if="!$v.input['amsCustomerDetail.picLastName'].required">
                            {{ $t('MSG_TRS_NAF_0004_param', {param1 : $t('profile.label.pic_last_name')})}}
                        </div>
                    </div>
                </div>
            </div>

            <div class="form-group row">
                <label class="control-label col-md-3 col-form-label"
                       for="picFirstName">{{$t('profile.label.pic_first_name')}}</label>
                <div class="col-md-6">
                    <input type="text" class="form-control"
                           v-model="$v.input['amsCustomerDetail.picFirstName'].$model"
                           id="picFirstName"
                           name="picFirstName"
                           required
                           maxlength="20"
                           v-convert-halfwidth-to-fullwidth>
                    <div v-if="$v.input['amsCustomerDetail.picFirstName'].$error || $v.input['amsCustomerDetail.picFirstName'].$anyError"
                         class="error-messages ng-active">
                        <div v-if="!$v.input['amsCustomerDetail.picFirstName'].required">
                            {{ $t('MSG_TRS_NAF_0004_param', {param1 : $t('profile.label.pic_first_name')}) }}
                        </div>
                    </div>
                </div>
            </div>

            <div class="form-group row">
                <label class="control-label col-md-3 col-form-label" for="picLastNameKana">{{$t('profile.label.pic_last_name_kana')}}</label>
                <div class="col-md-6">
                    <input type="text" class="form-control"
                           v-model="$v.input['amsCustomerDetail.picLastNameKana'].$model"
                           id="picLastNameKana"
                           name="picLastNameKana"
                           required
                           maxlength="20"
                           v-special-characters-validator
                           v-convert-kana-word
                    >
                    <div v-if="$v.input['amsCustomerDetail.picLastNameKana'].$error || $v.input['amsCustomerDetail.picLastNameKana'].$anyError"
                         class="error-messages ng-active">
                        <div v-if="!$v.input['amsCustomerDetail.picLastNameKana'].required">
                            {{ $t('MSG_TRS_NAF_0004_param', {param1 : $t('profile.label.pic_last_name_kana')}) }}
                        </div>
                    </div>
                </div>
            </div>

            <div class="form-group row">
                <label class="control-label col-md-3 col-form-label" for="picFirstNameKana">{{$t('profile.label.pic_first_name_kana')}}</label>
                <div class="col-md-6">
                    <input type="text" class="form-control"
                           v-model="$v.input['amsCustomerDetail.picFirstNameKana'].$model"
                           id="picFirstNameKana"
                           name="picFirstNameKana"
                           required
                           maxlength="20"
                           v-special-characters-validator
                           v-convert-kana-word
                    >
                    <div v-if="$v.input['amsCustomerDetail.picFirstNameKana'].$error || $v.input['amsCustomerDetail.picFirstNameKana'].$anyError"
                         class="error-messages ng-active">
                        <div v-if="!$v.input['amsCustomerDetail.picFirstNameKana'].required">
                            {{ $t('MSG_TRS_NAF_0004_param', {param1 : $t('profile.label.pic_first_name_kana')}) }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-group row">
                <label class="control-label col-md-3 col-form-label">{{$t('profile.label.upload.title')}}</label>
                <div class="col-md-6">
                    <FileInput v-model="$v.fileCustomerPicName1.$model" name="fileCustomerPicName1"></FileInput>
                    <error-messages-block :field="$v.fileCustomerPicName1">
                        <template #fileTypeValidation>
                            {{$t('profile.error.file_type',{param1 : fileTypeExtension})}}
                        </template>
                        <template #fileSizeValidation>
                            {{$t('profile.error.file_size')}}
                        </template>
                        <template #fileCustomerNameDuplicateValidation>
                            {{$t('profile.error.file_duplicate')}}
                        </template>
                    </error-messages-block>
                </div>
            </div>
            <div class="form-group row">
                <div class="col-md-6 offset-md-3">
                    <FileInput v-model="$v.fileCustomerPicName2.$model" name="fileCustomerPicName2"></FileInput>
                    <error-messages-block :field="$v.fileCustomerPicName2">
                        <template #fileTypeValidation>
                            {{$t('profile.error.file_type',{param1 : fileTypeExtension})}}
                        </template>
                        <template #fileSizeValidation>
                            {{$t('profile.error.file_size')}}
                        </template>
                        <template #fileCustomerNameDuplicateValidation>
                            {{$t('profile.error.file_duplicate')}}
                        </template>
                    </error-messages-block>
                </div>
            </div>
            <div class="form-group row">
                <div class="col-md-6 offset-md-3">
                    <FileInput v-model="$v.fileCustomerPicName3.$model" name="fileCustomerPicName3"></FileInput>
                    <error-messages-block :field="$v.fileCustomerPicName3">
                        <template #fileTypeValidation>
                            {{$t('profile.error.file_type',{param1 : fileTypeExtension})}}
                        </template>
                        <template #fileSizeValidation>
                            {{$t('profile.error.file_size')}}
                        </template>
                        <template #fileCustomerNameDuplicateValidation>
                            {{$t('profile.error.file_duplicate')}}
                        </template>
                    </error-messages-block>
                </div>
            </div>
            <div class="form-group row">
                <div class="col-md-12">
                    <div class="alert alert-warning">
                        <div>
                            {{$t('profile.pic.after_upload2')}}
                            <a :href="SUPPORT_DOCUMENT_URL" target="_blank">{{$t('profile.require.document')}}</a>
                            {{$t('profile.pic.after_upload_footer')}}
                        </div>
                        <div>
                            {{$t('profile.pic.after_upload')}}
                            <a :href="SUPPORT_DOCUMENT_URL" target="_blank">{{$t('profile.require.document')}}</a>
                            {{$t('profile.pic.after_upload_footer')}}
                        </div>
                        {{$t('profile.pic.after_upload_footer2')}}
                    </div>
                </div>
            </div>
            <template v-if="this.isParentScreenEditProfile">
                <div class="form-action">
                    <button class="btn btn-sm btn-submit btn-success mr-2"
                            :disabled="isDisabledButtonSubmit && isInvalidFile"
                            :type="this.getButtonType()">
                        {{$t('profile.button.change')}}
                    </button>
                    <button class="btn btn-default btn-cancel btn-sm"
                            type="button"
                            @click="reverseInput">
                        {{$t('profile.button.cancel')}}
                    </button>
                </div>
            </template>
        </ForceNewsBlockWrapper>
    </div>
</template>

<script>
/**
 * @author HungNS
 */
import {required} from 'vuelidate/lib/validators'
import formMixin from '@/common/mixins/form';

export default {
        name: "UpdateCustomerPicName",
        props: {},
        mixins: [formMixin],
        data: function () {
            return {
                fileCustomerPicName1: null,
                fileCustomerPicName2: null,
                fileCustomerPicName3: null,
            }
        },
        computed: {
            SUPPORT_DOCUMENT_URL() {
                return this.$store.state[this.namespace].SUPPORT_DOCUMENT_URL
            },
            fileUploadExt() {
                return this.$store.state.header.headerInfo.fileUploadExt
            },
            fileTypeExtension() {
                return this.fileUploadExt.toUpperCase();
            },
            isInvalidFile() {
              const {$v} = this;
              return $v.$anyError ||
                  (this.fileCustomerPicName1 === null &&
                  this.fileCustomerPicName2 === null &&
                  this.fileCustomerPicName3 === null);
            },
        },
        validations() {
            const initValidData = this.getInitFileValidation({...this.$data}, [], undefined, true);
            return {
                input: {
                    'amsCustomerDetail.picFirstName': {
                        required,
                    },
                    'amsCustomerDetail.picFirstNameKana': {
                        required,
                    },
                    'amsCustomerDetail.picLastName': {
                        required,
                    },
                    'amsCustomerDetail.picLastNameKana': {
                        required,
                    },
                },
                ...initValidData
            }

        },
        methods: {},
        mounted() {
        }

    }
</script>
<style scoped>
    .form-group {
        margin-bottom: 5px;
        padding-bottom: 15px;
    }
</style>

